module.exports = __webpack_public_path__ + "static/media/CNXFMCG.29d51be9.txt";